import React, { Component } from 'react';
import styled from 'styled-components';

const StyledSdkContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  &:before {
    z-index: 1;
    pointer-events: none;
    overflow: hidden;
    position: absolute;
    top: 0; left: 0;
    content: '';
    width: 100%; height: 100%;
    background: linear-gradient(to bottom, rgba(0,0,0,.25) 0%, rgba(0,0,0,0) 40%);
  }
`;

const containerId = 'sdkEffectContainerWrapper';

export class SdkRenderContainer extends Component {
  componentDidMount = () => {
    const { ARMethods } = this.props;
    ARMethods.renderInitialImage(containerId);
  }

  onClickHandler = () => {
    const { focusOnSkinFinding } = this.props;
    focusOnSkinFinding('reset');
  }

  render = () => {
    const { ARAnimation, onClickEnabled, animationEnabled } = this.props;
    return (
      <StyledSdkContainerWrapper id={containerId} style={animationEnabled ? ARAnimation : {}} onClick={onClickEnabled ? this.onClickHandler : ()=>{}}>
      </StyledSdkContainerWrapper>
    )
  }
}

export class SdkRenderContainerForAnalysis extends Component {
  render = () => {
    return (
      <SdkRenderContainer
        animationEnabled = {true}
        onClickEnabled={true}
        ARMethods={this.props.ARMethods}
        ARAnimation={this.props.ARAnimation}
        focusOnSkinFinding = {this.props.focusOnSkinFinding}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/instore/SdkRenderContainer.js